export const paymentsMap = {
  min_pct: 'commercialMinPercentage',
};

export const pricesMap = {
  default_price_cents: 'commercialDefaultPriceCents',
  min_price_cents: 'commercialMinPriceCents',
};

export const productsMap = {
  include_financial_protection_insurance: 'commercialProductsincludeFinancialProtectionInsurance',
  include_capitalization_bond: 'commercialProductsincludeCapitalizationBond',
  include_asset_insurance: 'commercialProductsincludeAssetInsurance',
  include_personal_insurance: 'commercialProductsincludePersonalInsurance',
};

export const returnsMap = {
  min_return: 'commercialMinReturn',
  max_return: 'commercialMaxReturn',
  return_preference: 'commercialReturnPreference',
  quota_preference: 'commercialReturnQuotaPreference',
};

export const storesMap = {
  store_id: 'commercialStoreId',
  store_separator: 'commercialStoreSeparator',
};

export default {
  has_vehicle: 'commercialHasVehicle',
  vehicle_model_id: 'commercialVehicleId',
  has_bank: 'commercialHasBank',
  bank_id: 'commercialBankId',
  bank_separator: 'commercialBankSeparator',
};
